import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { optionTypeAsync, patientAssessmentAsyncOverride, setTissueTypesData } from "../../../../../app/patientSlice";
import { useParams } from "react-router-dom";

const OPTION_TYPES = ["historycause", "pihistory", "woundage", "phototype", "documentationtype"];

export const useCharacteristicInit = ({ setDefaultIndex, prevDefaultIndex }) => {
  const dispatch = useDispatch();
  const { assessmentId } = useParams();

  useEffect(() => {
    if (!assessmentId) return;

    setDefaultIndex(0);
    dispatch(setTissueTypesData({}));
    dispatch(patientAssessmentAsyncOverride({ assessmentId }));
    prevDefaultIndex.current = 0;

    OPTION_TYPES.forEach((type) => {
      dispatch(optionTypeAsync(type));
    });
  }, [assessmentId, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps
};
